import type { UseEmblaCarouselType } from 'embla-carousel-react';

// Short and light so a photo reads as coming into focus rather than as lag:
// one opacity and blur animation that leaves no filter behind, since a
// lingering filter keeps a stacking context (see globals.css).
const REVEAL_KEYFRAMES: Keyframe[] = [
  { opacity: 0, filter: 'blur(10px)' },
  { opacity: 1, filter: 'blur(0)' },
];

// A photo already partly on screen, as one swiped in is, only sharpens: fading
// it from transparent would make it vanish at the moment the finger lifts.
const FOCUS_KEYFRAMES: Keyframe[] = [
  { filter: 'blur(10px)' },
  { filter: 'blur(0)' },
];

const REVEAL_TIMING: KeyframeAnimationOptions = {
  duration: 350,
  easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
};

const play = (img: Element | null | undefined, keyframes: Keyframe[]) => {
  if (!img || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }
  img.animate(keyframes, REVEAL_TIMING);
};

export const playImageReveal = (img: Element | null | undefined) =>
  play(img, REVEAL_KEYFRAMES);

export const playImageFocus = (img: Element | null | undefined) =>
  play(img, FOCUS_KEYFRAMES);

export const selectedSlideImage = (
  emblaApi: NonNullable<UseEmblaCarouselType[1]>
) => emblaApi.slideNodes()[emblaApi.selectedScrollSnap()]?.querySelector('img');
